export default __webpack_public_path__ + "static/media/prize-4-cn.10278a00.webp";